<template>
  <div
    class="project-structure-taktarea font-weight-light"
    >
    <div
      class="project-structure-taktarea-header"
      :style="show_steps?`height: calc(var(--project_structure_taktarea_steps_height) * 1px)`:''"
      @click="$emit('headerClick')"
      >
      <div
        class="project-structure-taktarea-header-name"
        >
        <div
          class="project-structure-taktarea-delete"
          >
          <slot name="delete"/>
        </div>
        <div
          v-if="taktarea.elements.length !== 0"
          class="project-structure-taktarea-marker"
          :style="hover || arrayIncludesArray(taktarea.elements, hover_el_ids).includes?'background-color: #009688':''"
          />
        <v-btn icon
          @click.prevent.stop="$emit('closeTaktarea')"
          style="height: 24px; width: 24px"
          >
          <v-icon
            style="cursor: pointer"
            >
            {{taktarea.closed?'keyboard_arrow_right':'keyboard_arrow_down'}}
          </v-icon>
        </v-btn>
        <div
          v-if="!isEditMode"
          style="width: 50px; overflow: hidden; white-space: nowrap"
          >
          {{taktarea.name}}
        </div>
        <input
          style="width: 50px"
          v-else
          class="project-structure-tree-input-field"
          :value="taktarea.name"
          @change="$emit('changeValue', {
            key: 'name',
            value: $event.target.value,
            })"
          />
        </div>
        <div class="project-structure-taktarea-header-activator">
          <slot name="activator"/>
        </div>
        <div class="project-structure-taktarea-header-waggons">
          <slot name="waggons"/>
        </div>
    </div>
    <div
      class="project-structure-taktarea-body"
      v-if="!taktarea.closed"
      >
      <div class="project-structure-taktarea-body-name">
        <slot name="body_name"/>
      </div>
      <div class="project-structure-taktarea-body-step-matrix">
        <slot name="step_matrix"/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['taktarea', 'isEditMode', 'hover', 'hover_el_ids', 'show_steps'],
    data: () => ({
    }),
    methods: {
      arrayIncludesArray(array1, array2) {
        if (array1.length === 0 || array2.length === 0) {
          return {includes: false, complete: false};
        }
        let set1 = new Set(array1);
        let set2 = new Set(array2);

        function isSuperset(set, subset) {
            for (var elem of subset) {
                if (!set.has(parseInt(elem))) {
                    return false;
                }
            }
            return true;
        }

        if (isSuperset(set1, set2)) {
          return {includes: true, complete: true};
        }

        function intersection(setA, setB) {
            var _intersection = new Set();
            for (var elem of setB) {
                if (setA.has(parseInt(elem))) {
                    _intersection.add(parseInt(elem));
                }
            }
            return _intersection;
        }
        let element_intersection = intersection(set1, set2);

        if (element_intersection.size === 0) {
          // console.log('getVisibility end');
          return {includes: false, complete: false};
        } else {
          // console.log('getVisibility end');
          return {includes: true, complete: false};
        }
      },
    }
  }
</script>
<style>
  .project-structure-taktarea {
    position: relative;
    user-select: none;
    /* border-top: solid black 1px; */

  }
  .project-structure-taktarea-header {
    height: 24px;
    display: flex;
    flex-shrink: 0;
    align-items: flex-end;
    overflow: hidden;
    min-height: 24px;
    /* transition: height 0.2s ease-in-out;
    transform: translateZ(0); */
  }
  .project-structure-taktarea-header-name {
    position: sticky;
    /* left: 4px; */
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: var(--project_structure_ta_header_width);
    overflow: hidden;
    z-index: 2;
    background-color: rgb(41,41,41);
    padding-left: 24px;
    border-right: solid black 1px;
    white-space: nowrap;
    user-select: none;
  }
  .project-structure-taktarea-header-waggons {
    display: flex;
    flex-shrink: 0;
  }
  .project-structure-taktarea-header:hover .project-structure-taktarea-delete {
    display: flex;
    flex-shrink: 0;
  }
  .project-structure-taktarea-delete {
    display: none;
    position: absolute;
    left: 0px;
    z-index: 4;
  }
  .project-structure-taktarea-body {
    display: flex;
    flex-shrink: 0;
    /* align-items: center; */
  }
  .project-structure-taktarea-body-name {
    position: sticky;
    left: 48px;
    margin-left: 48px;
    width: calc(var(--project_structure_ta_header_width) - 48px);
    overflow: hidden;
    border-right: solid black 1px;
    flex-shrink: 0;
  }
  .project-structure-taktarea-body-step-matrix {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
  .project-structure-taktarea-marker {
    position: absolute;
    height: 6px;
    width: 6px;
    border-radius: 6px;
    margin-left: -15px;
    margin-right: 9px;
    background-color: rgba(255,255,255, 0.4);
  }
  .project-structure-taktarea-header-activator {
    position: relative;
    height: 24px;
  }
</style>
